var map = {
	"./README.md": "Hj84",
	"./en": "3NCY",
	"./en.ts": "3NCY",
	"./en/": "LRm5",
	"./en/documentation": "6skC",
	"./en/documentation.ts": "6skC",
	"./en/head-seo": "Azp4",
	"./en/head-seo.ts": "Azp4",
	"./en/index": "LRm5",
	"./en/index.ts": "LRm5",
	"./en/nav": "Pfhg",
	"./en/nav.ts": "Pfhg",
	"./en/playground": "rvpb",
	"./en/playground.ts": "rvpb",
	"./en/tsconfig": "Pmsi",
	"./en/tsconfig.ts": "Pmsi",
	"./ja": "Yv0w",
	"./ja.ts": "Yv0w",
	"./ja/playground": "2e90",
	"./ja/playground.ts": "2e90",
	"./vo": "oqfC",
	"./vo.ts": "oqfC",
	"./vo/nav": "QhMr",
	"./vo/nav.ts": "QhMr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YWK9";